import { Parcel, SoilZones, Metrics } from '../types';
import { CLASSES, RULES, SOIL_MOD, CLASS_BY_ID } from '../constants/landUseConfig';

export function computeMetrics(polygons: Parcel[], soilBySide: SoilZones): Metrics {
  const perClass: Record<string, any> = {};
  CLASSES.forEach((c) => {
    perClass[c.id] = {
      areaHa: 0,
      count: 0,
      econ: 0,
      carbon: 0,
      bioWeighted: 0,
      modWeighted: 0,
    };
  });

  let totalEcon = 0,
    totalCarbon = 0,
    totalArea = 0,
    bioAccum = 0;

  polygons.forEach((p) => {
    const soil = soilBySide[p.soilZone];
    const rule = RULES[p.cls];
    const mod = SOIL_MOD[p.cls][soil];
    const factor = 1 + mod / 100;
    const econ = rule.econ * factor * p.areaHa;
    const carbon = rule.carbon * factor * p.areaHa;
    const bio = rule.bio * factor;

    totalEcon += econ;
    totalCarbon += carbon;
    totalArea += p.areaHa;
    bioAccum += bio * p.areaHa;

    const b = perClass[p.cls];
    b.areaHa += p.areaHa;
    b.count += 1;
    b.econ += econ;
    b.carbon += carbon;
    b.bioWeighted += bio * p.areaHa;
    b.modWeighted += mod * p.areaHa;
  });

  const classRows = CLASSES.map((c) => {
    const b = perClass[c.id];
    return {
      id: c.id,
      label: c.label,
      areaHa: b.areaHa,
      count: b.count,
      econ: b.econ,
      carbon: b.carbon,
      avgBio: b.areaHa > 0 ? b.bioWeighted / b.areaHa : 0,
      avgMod: b.areaHa > 0 ? b.modWeighted / b.areaHa : 0,
    };
  });

  return {
    totalEcon,
    totalCarbon,
    totalArea,
    avgBio: totalArea > 0 ? bioAccum / totalArea : 0,
    classRows,
  };
}

export function createSignature(polygons: Parcel[], soil: SoilZones): string {
  return (
    polygons.map((p) => p.id + ':' + p.cls).join('|') +
    '::' +
    soil.organic +
    ':' +
    soil.mineral
  );
}